import { isEmpty, get, map } from 'lodash'

const ObjectIsClean = object => {
  return typeof object === 'object' && Object.keys(object).length < 1
}
const deleteNullKey = (filters, key) => {
  if (!get(filters, key, null) || (Array.isArray(filters[key]) && filters[key].length < 1) || ObjectIsClean(filters[key])) {
    delete filters[key]
  }
}

const deleteNullKeys = (filters, keys) => {
  map(keys, key => {
    return deleteNullKey(filters, key)
  })
}

const filterDelete = (filters, key, newKey, deleteKey) => {
  const value = get(filters, key, null)
  if (value) {
    filters[newKey] = value
  }

  delete filters[deleteKey]
}

export default (filters) => {
  deleteNullKeys(filters['location'], ['id', 'distance'])
  deleteNullKeys(filters, ['location', 'covenant_id', 'schedules', 'covenants', 'price_start', 'price_end'])
  filterDelete(filters, 'professional.id', 'professional_id', 'professional')

  if (typeof filters['patient'] !== 'undefined') {
    delete filters['patient']['label']
    if (filters['patient']['id'] === null) {
      delete filters['patient']['id']
    }
    if (filters['patient']['type'] === null) {
      delete filters['patient']['type']
    }
    if (isEmpty(filters['patient'])) {
      delete filters['patient']
    }
  }

  if (typeof filters['location'] !== 'undefined') {
    filters['address'] = {
      location: {...filters['location']}
    }
    delete filters['location']
  }

  if (Array.isArray(filters.speciality)) {
    delete filters.speciality.name
    delete filters.speciality.first
    delete filters.speciality.occupation_area
    delete filters.speciality.deleted_at
  }

  return filters
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/getters/filtersToSearch.js